<app-spinner-overlay [showSpinner]="loading"></app-spinner-overlay>
<wl-card heading="Customer Consent Form" *ngIf="!kcc_form_disable && landRecordStatus">

  <div [ngStyle]="pointerStyle">
    <h2 class="text-center"> Application Form - Annexure II</h2>

    <h3 class="text-center">Digital Renewal of UGC (KCC loans) of upto Rs.{{loanAmountInDecimals}} lakhs</h3>
    <form novalidate [formGroup]="bankAccForm">

      <wl-card heading="Borrower Details">

        <wl-input type="text" label="Name of the Borrower" formControlName="name_of_borrower" [readonly]="true"
          disabled>
        </wl-input>

        <wl-input type="text" label="Name of Co Applicant/s" formControlName="name_of_co_applicant" [readonly]="true"
          disabled></wl-input>

        <wl-input type="text" label="Correspondence Address" formControlName="corps_address" [readonly]="true" disabled>
        </wl-input>

        <wl-input type="text" label="Customer ID" formControlName="customer_id" [readonly]="true" disabled></wl-input>

        <wl-input type="text" label="Account No." formControlName="bank_acc_no" [readonly]="true" disabled></wl-input>

      </wl-card>

      <wl-card heading="Existing Loan Details">
        <div child-container class="table table-bordered table-responsive">
          <table class="table table-hover">
            <thead>
              <tr>
                <th class="text-center">Type of Facilities</th>
                <th class="text-center">Existing Limit(in Rs)</th>
                <th class="text-center">Outstanding (in Rs)</th>
                <th class="text-center">ROI(%)
                </th>
                <th class="text-center">Margin(%)
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <wl-input-nolabel type="text" class="text-center" formControlName="type_of_facility"
                    [readonly]="true" disabled></wl-input-nolabel>
                </td>
                <td class="text-center">
                  <wl-input-nolabel type="text" class="text-center" formControlName="existing_loan_in_lakhs"
                    [readonly]="true" disabled></wl-input-nolabel>
                </td>
                <td class="text-center">
                  <wl-input-nolabel type="text" class="text-center" formControlName="outstanding_as_on"
                    [readonly]="true" disabled></wl-input-nolabel>
                </td>
                <td class="text-center">
                  <wl-input-nolabel type="text" class="text-center" formControlName="roi" [readonly]="true"
                    disabled>
                  </wl-input-nolabel>
                </td>
                <td class="text-center">
                  <wl-input-nolabel type="text" class="text-center" formControlName="margin" [readonly]="true"
                    disabled>
                  </wl-input-nolabel>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </wl-card>

      <wl-card heading="Renewal of Credit Limit">
        <wl-input type="text" label="Due date of Renewal of Credit Limit" formControlName="due_date_of_renew"
          [readonly]="true" disabled></wl-input>
      </wl-card>




      <wl-card heading="Renewal of KCC">

        <div>
          <div class="flex flex-row flex-start">
            <h3>A. Credit Facilities</h3>
          </div>
          <!-- *ngIf="kcc_form_flag" -->
          <table class="table table-hover table-bordered">
            <thead>
              <tr>
                <th class="text-center">Existing (in Rs)</th>

              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="text-center w-45pct">
                  <wl-input-nolabel type="text" class="text-center mr-20px" placeholder="As per CBS"
                    [readonly]="true" formControlName="kcc_loanamt_cbs" disabled></wl-input-nolabel>
                </td>

              </tr>
            </tbody>
          </table>
          <label>
            <p><b>Whether Renewal of KCC Limit is Requested ?</b></p>
            <mat-radio-group class="text-right pt-20px flex-1-30" formControlName="is_renewal_kcc_limit_required">
              <mat-radio-button color="primary" class="example-margin" (click)="showkccform()" value="yes">Yes</mat-radio-button>
              <mat-radio-button color="primary" class="example-margin" (click)="consent_form_hide()" value="no">No</mat-radio-button>
            </mat-radio-group>
            
          </label>

          <div class="flex flex-row flex-start">
            <h3>B. Proposed Cropping Pattern:</h3>
          </div>

          <!-- <span class="text-B60A0A text-left">*To be reviewed, updated and confirmed by RO</span> -->

          <form novalidate [formGroup]="multiCropDetailsForm">
            <div child-container class="table-responsive">
              <table class="table table-hover table-bordered">
                <tr>
                  <th>Sr. No.</th>
                  <th>Cropping season</th>
                  <th class="text-left w-35pct border-right-none">Name of the Crop - List </th>
                  <th colspan="1" class="text-right border-left-none pr-10pct">Crop Area - in
                    {{acreOrHectare}}s</th>
                  <th colspan="1" class="text-right">Actions</th>
                </tr>
                <tr>
                  <td class="vertical-align-top pt-40px">1</td>
                  <td class="vertical-align-top pt-40px">Kharif</td>
                  <td colspan="2">
                    <div formArrayName="cropArrayKharif">
                      <table class="table table-borderless">
                        <tbody>
                          <tr *ngFor="let cropArray of cropArrayKharif().controls; let i=index" [formGroupName]="i">

                            <td class="text-center">
                              <br>
                              <wl-autocomplete placeholder="Choose a Crop" formControlName="kharif"
                                [options]="newCrops ? newCrops:kharifCropListNew2"
                                (selected)="kharifSelectedEvent($event,i)" (keyup)="checkForEmpty()">
                              </wl-autocomplete>
                              <div class="display-none">
                                <wl-input type="text" formControlName="kharifId"></wl-input>
                              </div>
                            </td>
                            <td>
                              <div class="pt-20px">
                                <wl-input-nolabel type="number" placeholder="Enter in {{acreOrHectare}}s"
                                  (keyup)="totalacres(i)" formControlName="kharif_acres" [readonly]="kharifDisabled"
                                  class="bg-c21111"></wl-input-nolabel>
                              </div>
                            </td>
                            <td *ngIf="showGuntas">
                              <div class="pt-20px">
                                <wl-input-nolabel type="number" placeholder="Enter in Guntas" (keyup)="totalacres(i)"
                                  formControlName="kharif_guntas" [readonly]="kharifDisabled"></wl-input-nolabel>
                              </div>
                            </td>

                            <td class="vertical-align-middle">

                              <img class="deleteIcon h-30px"
                                src="../../../assets/fontawesome-web/svgs/regular/trash-can.svg"
                                (click)=" removeRowKharif(i)">
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                  <td class="vertical-align-bottom text-center">

                    <img class="deleteIcon h-30px"
                      src="../../../assets/fontawesome-web/svgs/regular/square-plus.svg" (click)=" addKharifCrop(i)">
                  </td>
                </tr>
                <tr>
                  <td class="vertical-align-top pt-40px">2</td>
                  <td class="vertical-align-top pt-40px">Rabi</td>
                  <td colspan="2">
                    <div formArrayName="cropArrayRabi">
                      <table class="table table-borderless">
                        <tbody>
                          <tr *ngFor="let cropArray of cropArrayRabi().controls; let i=index" [formGroupName]="i">

                            <td class="text-center">
                              <br>
                              <wl-autocomplete placeholder="Choose a Crop" formControlName="rabi"
                                [options]="newCrops ? newCrops:rabiCropListNew2"
                                (selected)="rabiSelectedEvent($event,i)" (keyup)="checkForEmpty()">
                              </wl-autocomplete>
                              <div class="display-none">
                                <wl-input type="text" formControlName="rabiId"></wl-input>
                              </div>
                            </td>
                            <td>
                              <div class="pt-20px">
                                <wl-input-nolabel type="number" placeholder="Enter in {{acreOrHectare}}s"
                                  (keyup)="totalacres(i)" formControlName="rabi_acres" [readonly]="rabiDisabled"
                                  class="bg-c21111"></wl-input-nolabel>
                              </div>
                            </td>
                            <td *ngIf="showGuntas">
                              <div class="pt-20px">
                                <wl-input-nolabel type="number" placeholder="Enter in Guntas" (keyup)="totalacres(i)"
                                  formControlName="rabi_gunta" [readonly]="rabiDisabled"></wl-input-nolabel>
                              </div>
                            </td>
                            <td class="vertical-align-middle">

                              <img class="deleteIcon h-30px"
                                src="../../../assets/fontawesome-web/svgs/regular/trash-can.svg"
                                (click)=" removeRowRabi(i)">
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                  </td>
                  <td class="vertical-align-bottom text-center">

                    <img class="deleteIcon h-30px"
                      src="../../../assets/fontawesome-web/svgs/regular/square-plus.svg" (click)=" addRabiCrop(i)">
                  </td>
                </tr>
                <tr class="display-none">
                  <td class="vertical-align-top pt-40px">3</td>
                  <td class="vertical-align-top pt-40px">Summer</td>
                  <td colspan="2">
                    <div formArrayName="cropArraySummer">
                      <table class="table table-borderless">
                        <tbody>
                          <tr *ngFor="let cropArray of cropArraySummer().controls; let i=index" [formGroupName]="i">

                            <td class="text-center">
                              <br>
                              <wl-autocomplete placeholder="Choose a Crop" formControlName="summer" [options]="newCrops"
                                (selected)="summerSelectedEvent($event,i)" (keyup)="checkForEmpty()">
                              </wl-autocomplete>
                              <div class="display-none">
                                <wl-input type="text" formControlName="summerId"></wl-input>
                              </div>
                            </td>
                            <td>
                              <div class="pt-20px">
                                <wl-input-nolabel type="number" placeholder="Enter in {{acreOrHectare}}s"
                                  (keyup)="totalacres(i)" formControlName="summer_acres" [readonly]="summerDisabled"
                                  class="bg-c21111"></wl-input-nolabel>
                              </div>
                            </td>
                            <td *ngIf="showGuntas">
                              <div class="pt-20px">
                                <wl-input-nolabel type="number" placeholder="Enter in Guntas" (keyup)="totalacres(i)"
                                  formControlName="summer_gunta" [readonly]="summerDisabled"></wl-input-nolabel>
                              </div>
                            </td>
                            <td class="vertical-align-middle">

                              <i class="font-size-25px fa fa-trash-o deleteIcon fa-1x"
                                (click)=" removeRowSummer(i)"></i>
                              <img class="deleteIcon h-30px"
                                src="../../../assets/fontawesome-web/svgs/regular/trash-can.svg"
                                (click)=" removeRowSummer(i)">
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                  </td>
                  <td class="vertical-align-bottom text-center">

                    <img class="deleteIcon h-30px"
                      src="../../../assets/fontawesome-web/svgs/regular/square-plus.svg" (click)=" addSummerCrop(i)">

                  </td>
                </tr>
                <tr>
                  <td colspan="4" class="text-right">

                    <wl-input type="text" [readonly]="true" label="Total in {{acreOrHectare}}s"
                      [(ngModel)]="acressumnum" formControlName="acressumnum" disabled></wl-input>

                    <div class="display-none">
                      <wl-input type="text" [readonly]="true" label="Total in {{acreOrHectare}}s"
                        formControlName="kharifTotal" disabled [(ngModel)]="hectaresKharif"></wl-input>
                      <wl-input type="text" [readonly]="true" label="Total in {{acreOrHectare}}s"
                        formControlName="rabiTotal" disabled [(ngModel)]="hectaresRabi"></wl-input>
                      <wl-input type="text" [readonly]="true" label="Total in {{acreOrHectare}}s"
                        formControlName="summerTotal" disabled [(ngModel)]="hectaresSummer"></wl-input>
                    </div>



                    <p *ngIf="showMPCroppingPattern" class="text-center">Total Land-area as per Land-records -
                      <strong>{{totalLandArea}}
                        {{acreOrHectare}}s</strong>
                    </p>
                    <div class="text-white">{{multiCropDetailsForm.valid}} {{disableSubmitFromMulticrop}}</div>
                  </td>
                </tr>
              </table>
            </div>
          </form>

          <div class="row">
            <p><b>
                Customer to select proposed crop from dropdown. (list of major crops for the state to be displayed and
                one
                option for others) if selected Others- customer to write the name of the crop in the box.
              </b></p>
          </div>
          <div class="row">
            <h3>C.Crop Insurance consent:</h3>
            <mat-radio-group class="text-right pt-20px flex-1-30" formControlName="is_cropping_insurance_required">
              <mat-radio-button color="primary" class="example-margin" value="yes">Yes</mat-radio-button>
              <mat-radio-button color="primary" class="example-margin" value="no">No</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
      </wl-card>

      <wl-card>
        <div class="table table-responsive">
          <table class="table table-hover table-bordered">
            <thead>
              <tr>
                <th class="text-center">Type of Facilities</th>

                <th class="text-center">Rate of Interest(%)</th>
                <th class="text-center">Minimum Margin(%)</th>
                <th class="text-center">Securities & </th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td class="text-left">
                  <wl-input-nolabel class="text-center w-10vw mr-20px" type="text"
                    formControlName="type_of_facilities" [readonly]="true" disabled></wl-input-nolabel>
                </td>

                <td class="text-left">
                  <wl-input-nolabel class="text-center w-10vw mr-20px" type="text"
                    formControlName="rate_of_interest" [readonly]="true" disabled>
                  </wl-input-nolabel>
                </td>
                <td class="text-left">
                  <wl-input-nolabel class="text-center w-10vw mr-20px" type="text"
                    formControlName="minimum_margin" [readonly]="true" disabled></wl-input-nolabel>
                </td>
                <td class="text-left">
                  <wl-input-nolabel class="text-center w-10vw mr-20px" type="text"
                    [readonly]="true" formControlName="securities" disabled></wl-input-nolabel>
                </td>

              </tr>
            </tbody>
          </table>
        </div>

        <p>
          * I/We hereby extent my consent for above mentioned KCC account on existing terms and conditions.
        </p>
      </wl-card>


      <wl-card heading="Declaration">
        <label>
          <input formControlName="declaration" type="checkbox" required />

          I/ We hereby certify that all information
          furnished above is true,
          correct and complete. I/ We have not availed any KCC/ Crop Loan except as indicated in the application.
          There is no overdue/ statutory dues against me/us. No legal action has been/ is being taken/
          initiated against me/us by any Bank/FIs.
          I/We shall furnish all other information that may be required in connection with my/ our application that this
          may also be exchanged by you with
          any agency you may deemed fit and you, your representatives or Reserve Bank of India or any other agency as
          authorized by you, may, at any time,
          inspect/verify my/our assets, books of accounts etc. You may take appropriate safeguards/action for recovery
          of Bank’s dues including publication
          of defaulter’s name in website/submission to RBI; further agree that my/our loan shall be governed by the
          rules of your Bank which may be in
          force from time to time.
          I/ We hereby authorise Union Bank of India to fetch my/ our CIC report from Credit Bureau Agency.
        </label>
      </wl-card>

      <div class="text-center">
        <br>
        <button class="mybutton" (click)="consentformSubmit()"
          [disabled]="!bankAccForm.valid || disableSubmitFromMulticrop || !multiCropDetailsForm.valid || hideSubmit || disabledByCreditCheck || disableSubmitConsentAlreadySubmitted || disableSentToCbsAlready || disableFailureInAssessmentStatus || loading || disableSubmitBasedOnCropValidity">
          Submit</button>
      </div>


<!-- {{!bankAccForm.valid}} , {{disableSubmitFromMulticrop}} , {{!multiCropDetailsForm.valid}} , {{hideSubmit}} , {{disabledByCreditCheck}} , {{disableSubmitConsentAlreadySubmitted}} , {{disableSentToCbsAlready}} , {{disableFailureInAssessmentStatus}} , {{loading}} , {{disableSubmitBasedOnCropValidity}} -->

    </form>
    <br>

  </div>
  <div class="text-center">
    <button class="mybutton" *ngIf="!reportLink && !isReportPending" (click)="generateReport()">Generate Consent
      Form</button>
    <div class="text-center-important">
      <mat-progress-spinner *ngIf="isReportPending" class="spinner-custom" mode="indeterminate">
      </mat-progress-spinner>
    </div>

    <button *ngIf="reportLink" (click)="downloadPdf()" class="mybutton" target="_blank">Download
      Consent Form</button>
  </div>
</wl-card>


<wl-card heading="Renewal Consent Form Confirmation" *ngIf="kcc_form_disable && landRecordStatus" id="kcc_form">
  <br>
  <br>
  <br>
  <br>
  <br>
  <br>
  <h3 id="ConsentText" class="text-center">The Customer file has been transfered to Consent 'NO'.</h3>
  <br>
  <br>
  <br>
  <br>
  <br>
  <br>
  <br>

</wl-card>

<wl-card heading="Customer Consent Form" *ngIf="!landRecordStatus">
  <br>
  <br>
  <br>
  <br>
  <br>
  <br>
  <h3 id="ConsentText" class="text-center">{{consentFormText}}</h3>
  <br>
  <br>
  <br>
  <br>
  <br>
  <br>
  <br>

</wl-card>

